/**
 * 继承配置的属性名
 */
export const extendKey = '$extends'
